import { defineMessages } from '@cookbook/solid-intl'

// Split out of `search-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Discover affordable short term rentals with Lodgr. Browse through unique and affordable short term rental stays from cottages, vacation homes, cabins, condos, and apartments.',
        id: 'SearchPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'Search Vacation Rentals | Lodgr',
        id: 'SearchPage.titleMessage',
    }),
}
